import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import axios from "axios";
import CONFIG from "./constanta/config";
import PageCheckinMobile from "./pages/checkin_mobile";
import PageRegisterEvent from "./pages/register_event";
import PageCheckoutGeneral from "./pages/checkout_general";
import PageLink from "./pages/link";
import PageCheckoutRFID from "./pages/checkout_rfid";
import PageCheckinName from "./pages/checkin_name";



function App() {
  const [totalCheckin, setTotalCheckin] = useState(0);
  const [totalCheckout, setTotalCheckout] = useState(0);
  const [totalRedeem, setTotalRedeem] = useState(0);
  const [setting, setSetting] = useState(null);

  useEffect(() => {
    // checkLocal();
    // getListSetting();
  }, []);

  const getListSetting = () => {
    axios
      .get(CONFIG.URL + "/config")
      .then(function (response) {
        if (response?.data.status === "SUCCESS") {
          setSetting(response?.data?.config);
        } else {
        }
      })
      .catch(function (error) {});
  };

  const checkLocalCheckin = () => {
    let checkin = window.localStorage.getItem("LocalCheckin");
    if (checkin) {
      setTotalCheckin(JSON.parse(checkin).length);
    } else {
      setTotalCheckin(0);
    }
  };

  const checkLocalCheckout = () => {
    let checkout = window.localStorage.getItem("LocalCheckout");
    if (checkout) {
      setTotalCheckout(JSON.parse(checkout).length);
    } else {
      setTotalCheckout(0);
    }
  };

  const checkLocalRedeem = () => {
    let redeem = window.localStorage.getItem("LocalRedeem");
    if (redeem) {
      setTotalRedeem(JSON.parse(redeem).length);
    } else {
      setTotalRedeem(0);
    }
  };

  const checkLocal = () => {
    checkLocalCheckin();
    checkLocalCheckout();
    checkLocalRedeem();
  };

  return (
    <>
      {/* <StatusInet
        totalCheckin={totalCheckin}
        totalCheckout={totalCheckout}
        totalRedeem={totalRedeem}
        checkLocal={() => checkLocal()}
      />
      <div className="pt-8"></div> */}

      <div className="overflow-y-auto">
        <Routes>
          <Route path="/" element={<PageLink setting={setting} />} />
          <Route path="/checkin" element={<PageCheckinMobile setting={setting} />} />
          {/* <Route path="/checkin-name" element={<PageCheckinName setting={setting} />} /> */}
          <Route path="/home" element={<PageCheckinMobile setting={setting} />} />
          <Route path="/checkout" element={<PageCheckoutRFID setting={setting} />} />
          <Route path="/add-user" element={<PageRegisterEvent setting={setting} />} />

          {/* <Route path="/" element={<PageRegisterEvent setting={setting} />} />
          <Route path="/login" element={<PageLogin setting={setting} />} />
          <Route path="/home" element={<PageHome setting={setting} />} />

          <Route
            path="/checkin"
            element={<PageCheckinMobile setting={setting} />}
          />

          <Route path="/gate" element={<PageEvent setting={setting} />} />

           */}

        </Routes>
      </div>
    </>
  );
}

export default App;
